// extracted by mini-css-extract-plugin
module.exports = {"container":"privacy-policy_container__2ud0y","innerWrapper":"privacy-policy_innerWrapper__3uBzP"};